import utils from '../common/util';
import * as timer from './cmp-countdown-timer';
import * as flashScreen from './cmp-flash-screen'
import * as dataContainer from './cmp-data-container'

const cmpLogResultBtn = {
    component: null,

    /**
     * Initialise the Log Results Buttons
     * @param element
     */
    init: function (element)
    {
        utils.log('cmpLogResultsBtn initiated : #' + element.id, 'info');

        const _ = utils.setEnvironment(this);
        _.component = element;

        _.clap = new Audio();
        _.clap.src = '/assets/audio/clap.mp3';
        _.boo = new Audio();
        _.boo.src = '/assets/audio/boo.mp3';

        _.onClickEvent(element);
    },

    /**
     * Set on click events for each button
     */
    onClickEvent: function (element)
    {
        const _ = this;

        element.addEventListener('click', () =>
        {
            utils.log('cmpLogResultsBtn clicked : #' + element.id, 'info');

			// play appropriate sounds
            if(element.classList.contains('opponent-failed-btn') || element.classList.contains('player-failed-btn'))
            {
                void _.boo.play();
            } else if(element.classList.contains('task-completed-btn'))
            {
                void _.clap.play();
            }

            // cancel the timer
            timer.default.stopTimer();

            // collect variables from the data container object and clicked button
            Object.assign(_, dataContainer.default.collectVariables());

            // get a random background image
            fetch(utils.getApiUrl() + '/images-random?' + new URLSearchParams({
                "gameLevelId": _.gameLevelId,
            }), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + _.bearerToken
                },
            })
                .then(response => response.json())
                .then(data =>
                {
                    // show the flash screen
                    let imgSrc = '/assets/img/backgrounds/' + data.data.filename;
					let imgOpacity = data.data.opacity;
                    flashScreen.default.showFlashScreen(element.id === 'task-complete-btn' ? 'pass' : 'fail', imgSrc, imgOpacity);
                })

            // log the play result
            fetch(utils.getApiUrl() + '/game-results', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + _.bearerToken
                },
                body: JSON.stringify({
                    "gameId": _.gameId,
                    "playerId": _.currentPlayerId,
                    "playId": _.playId,
                    "playerFailed": element.classList.contains('player-failed-btn') ? 1 : 0,
                    "opponentFailed": element.classList.contains('opponent-failed-btn') ? 1 : 0,
                    "taskCompleted": element.classList.contains('task-completed-btn') ? 1 : 0,
                })
            })
                .then(response => response.json())
        })
    },

    /**
     * Brings the log results buttons into view
     */
    showLogResultsButtons: function ()
    {
        const _ = this;

	    utils.animateAndShow(_.logResultsBtnContainer, 'opacity-0');
    },

    /**
     * Hides the log results buttons from the view
     */
    hideLogResultsButtons: function ()
    {
        const _ = this;

        utils.showHideElement(_.logResultsBtnContainer, 'hide');
        _.logResultsBtnContainer.classList.add('opacity-0');
    },

    swapDataContainerVariables: function ()
    {
        const _ = this;

        _.dataContainer.setAttribute('data-current-player-id', _.opponentPlayerId);
        _.dataContainer.setAttribute('data-current-player', _.opponentPlayer);
        _.dataContainer.setAttribute('data-opponent-player-id', _.currentPlayerId);
        _.dataContainer.setAttribute('data-opponent-player', _.currentPlayer);
        _.dataContainer.setAttribute('data-gender-target', _.genderTarget === 'to_male' ? 'to_female' : 'to_male');
    },

	/**
	 * Hide any single log results button
	 * @param id
	 */
	hideButton: function(id)
	{
		const _ = this;

		let button = document.getElementById(id) || null;

		if(button)
		{
			utils.showHideElement(button, 'hide');
		}
	},

	/**
	 * Hide any single log results button
	 * @param id
	 */
	showButton: function(id)
	{
		const _ = this;

		let button = document.getElementById(id) || null;

		if(button)
		{
			utils.showHideElement(button, 'show');
		}
	}
}

export default cmpLogResultBtn;
